<div class="modal-header">
  <div class="title">
    <h2 class="modal-title-prefix"><span translate="SPISAKISKORISCENIH.SINGULAR"></span></h2>
  </div>
  <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-md-12">
        <yt-fw-default-table
        *ngIf="modelData!=null && modelData.MainList!=null"
        [Config]="Config"
        [Items]="items"
        [TableColumns]="modelData.MainList.TableColumns"      
        [Condensed]="CondensedTable"
        [ShowLoader]="MainItemsLoading"
        (RefreshDataClicked)="RefreshData()"
        [RowColors]="rowColors"
      >
      </yt-fw-default-table>      
    </div>
  </div>
 
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" id="btnClose" (click)="Close()"><span>Zatvori</span></button>
  </div>